import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TemrVisitNonDrugAllergyService {
  temrVisitNonDrugAllergy: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'temr_visit_non_drug_allergy/list/?';
  private AddRecord = webapi + 'temr_visit_non_drug_allergy/create';
  private EditRecord = webapi + 'temr_visit_non_drug_allergy/update';
  private GetRecord = webapi + 'temr_visit_non_drug_allergy/byid/';
  private DeleteRecord = webapi + 'temr_visit_non_drug_allergy/delete/';
  private ListByVisitId = webapi + 'temr_visit_non_drug_allergy/listbyvisitid/';
  private ListBytimelineId = webapi + 'temr_visit_non_drug_allergy/listbytimelineid/';
  private ListBypatientId = webapi + 'temr_visit_non_drug_allergy/listByPatientId/';
  private GetAllRecordByTimelineList = webapi + 'temr_visit_non_drug_allergy/getAllRecordByTimelineList';
    private ContraindiactedListBytimelineId = webapi + 'temr_visit_non_drug_allergy/containdicatedlistbytimelineid/';
    private ContraindiactedListBytimelineId1 = webapi + 'temr_visit_non_drug_allergy/containdicatedlistbytimelineid1/';
    private ContraindiactedListBytimeline = webapi + 'temr_visit_non_drug_allergy/containdicatedlistbytimeline/';
  private FindNonDrugAllergyByPatientId = webapi + 'temr_visit_non_drug_allergy/findNonDrugAllergyByPatientId/';
  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getByVisitIdRecordService(id: any) {
    return this.http.get(this.ListByVisitId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getByTimelineIdRecordService(id: any) {
    return this.http.get(this.ListBytimelineId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
getByTimelineIdRecord(patientId: any) {
    return this.http.get(this.ListBypatientId + patientId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordByTimelineList(model: any) {
    return this.http.post(this.GetAllRecordByTimelineList, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
    getContraindicatedndAllryByTimelineId(id: any) {
        return this.http.get(this.ContraindiactedListBytimelineId + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    getContraindicatedndAllryByTimelineId2(id: any) {
        return this.http.get(this.ContraindiactedListBytimelineId1 + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  getContraindicatedndAllryByTimelineId1(currentPage: any, size: any, patientId: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ContraindiactedListBytimeline + 'page=' + currentPage + '&size=' + size + '&patientId=' + patientId + '&sort=' + sort + '&col=' + col)
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }
  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
  getFindNonDrugAllergyByPatientId(id: any) {
    return this.http.get(this.FindNonDrugAllergyByPatientId + id, {headers: this.headers})
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/temr-visit-non-drug-allergy/temr-visit-non-drug-allergy.service.ts